module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-order",
    staticStyle: {
      "background": "#f7f8fa"
    }
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('operaOrder_title'),
      "url": "/opera/fangT",
      "replace": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "room"
  }, [_c('span', [_vm._v(_vm._s(_vm.$route.query.rmno) + _vm._s(_vm.$t('operaOrder_room')))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form "
  }, [_c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('fangTXQ_rmtype')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookInfo.rmtype),
      expression: "bookInfo.rmtype"
    }],
    attrs: {
      "type": "text",
      "disabled": "",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.bookInfo.rmtype)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bookInfo, "rmtype", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookInfo.name),
      expression: "bookInfo.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('operaOrder_bookinfo_name')
    },
    domProps: {
      "value": (_vm.bookInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bookInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('mobile')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookInfo.mobile),
      expression: "bookInfo.mobile"
    }],
    attrs: {
      "type": "text",
      "placeholder": "$t('operaOrder_bookinfo_mobile')"
    },
    domProps: {
      "value": (_vm.bookInfo.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bookInfo, "mobile", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('book_idCode')))]), _vm._v(" "), _c('div', {
    staticClass: "parent",
    class: {
      focus: _vm.selectedInput == 'idCode'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputVal.idCode),
      expression: "inputVal.idCode"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.inputVal.idCode)
    },
    on: {
      "touchstart": function($event) {
        return _vm.showPop('idCode')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inputVal, "idCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-xia"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('book_idNo')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookInfo.idNo),
      expression: "bookInfo.idNo"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('book_idNo_placeholder_required')
    },
    domProps: {
      "value": (_vm.bookInfo.idNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bookInfo, "idNo", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('operaOrder_live_in_date')))]), _vm._v(" "), _c('div', {
    staticClass: "parent"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.openPick('picker')
      }
    }
  }, [_vm._v(_vm._s(_vm._f("fdate")(_vm.startTime.time)))]), _vm._v(" "), _c('mt-datetime-picker', {
    ref: "picker",
    attrs: {
      "type": "date",
      "startDate": _vm.minDate,
      "endDate": _vm.maxDate
    },
    on: {
      "confirm": _vm.handleConfirm
    },
    model: {
      value: (_vm.startTime.time),
      callback: function($$v) {
        _vm.$set(_vm.startTime, "time", $$v)
      },
      expression: "startTime.time"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('delayIn_EndDate')))]), _vm._v(" "), _c('div', {
    staticClass: "parent"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.openPick('picker2')
      }
    }
  }, [_vm._v(_vm._s(_vm._f("fdate")(_vm.endTime.time)))]), _vm._v(" "), _c('mt-datetime-picker', {
    ref: "picker2",
    attrs: {
      "type": "date",
      "startDate": _vm.minDate2,
      "endDate": _vm.maxDate
    },
    model: {
      value: (_vm.endTime.time),
      callback: function($$v) {
        _vm.$set(_vm.endTime, "time", $$v)
      },
      expression: "endTime.time"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('book_salesman')))]), _vm._v(" "), _c('div', {
    staticClass: "parent",
    class: {
      focus: _vm.selectedInput == 'salesMan'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputVal.salesMan),
      expression: "inputVal.salesMan"
    }],
    attrs: {
      "type": "text",
      "name": "",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.inputVal.salesMan)
    },
    on: {
      "touchstart": function($event) {
        return _vm.showPop('salesMan')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inputVal, "salesMan", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-xia"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('remark')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookInfo.remark),
      expression: "bookInfo.remark"
    }],
    staticClass: "remark",
    domProps: {
      "value": (_vm.bookInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bookInfo, "remark", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [(_vm.rights.indexOf('resrv!fit!add') >= 0) ? _c('div', {
    staticClass: "bookbtn",
    on: {
      "click": _vm.book
    }
  }, [_vm._v(_vm._s(_vm.$t('fangT_reserveBook')))]) : _vm._e(), _vm._v(" "), (_vm.rights.indexOf('recept!fit!ci') >= 0) ? _c('div', {
    staticClass: "bookbtn",
    on: {
      "click": _vm.checkIn
    }
  }, [_vm._v(_vm._s(_vm.$t('fangT_walkBook')))]) : _vm._e()]), _vm._v(" "), _c('mt-popup', {
    staticClass: "pop",
    attrs: {
      "position": "bottom",
      "modal": false,
      "closeOnClickModal": false
    },
    model: {
      value: (_vm.popupVisible),
      callback: function($$v) {
        _vm.popupVisible = $$v
      },
      expression: "popupVisible"
    }
  }, [_c('div', {
    staticClass: "roomNums"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('mt-button', {
    staticClass: "sure",
    on: {
      "click": _vm.changeValue
    }
  }, [_vm._v(_vm._s(_vm.$t('determine')))]), _vm._v(" "), _c('div', {
    staticClass: "cancel",
    on: {
      "touchstart": function($event) {
        _vm.popupVisible = false;
        _vm.selectedInput = ''
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-cuowu"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "warp"
  }, [_c('div', {
    staticClass: "rollWarp",
    attrs: {
      "id": "slideBlock"
    }
  }, [_c('mt-picker', {
    attrs: {
      "slots": _vm.optionSlot,
      "visible-item-count": 5,
      "itemHeight": 40
    },
    on: {
      "change": _vm.slideChange
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-14781d48","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/order.vue
// module id = 1736
// module chunks = 107